module.exports = __webpack_public_path__ + "static/media/slider-minimal-agency-slide-03-image-01.ff56cca9.jpg";